import BlackLogo from './img/PTT_current.png';
import { FaRegCopyright } from 'react-icons/fa6';
import './css/style.scss';

const Footer = () => {
  return (
    <div id='footer' className='row justify-content-center m-0'>
      <div className='reduced-row d-flex'>
        <div className='navbar-logo'>
          <img src={BlackLogo} alt='Accenture' />
        </div>
        <div className='copyrights'>
          <FaRegCopyright /> 2023 Accenture. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Footer;
